import React, { useEffect, useState } from 'react';
import { useSessionState } from '../hooks/useSessionState';
import RibbonActions from '../components/RibbonActions';
import { getOrdenesTrabajo, createOrdenTrabajo, updateEstadoOT, getProyectos } from '../services/api';
import { BotonesDocumento } from '../components/PrintView';
import FiltroPanel from '../components/FiltroPanel';
import DocHistorialModal, { ClockIcon } from '../components/DocHistorialModal';

const HIST_BTN = { background:'#1e293b', border:'1px solid #334155', borderRadius:6, padding:'4px 8px', cursor:'pointer', color:'#93c5fd', display:'inline-flex', alignItems:'center', verticalAlign:'middle', marginRight:6 };
const ESTADOS = ['abierta','en_progreso','cerrada'];
const PRIO    = ['alta','media','baja'];
const EC = { abierta:'#3b82f6', en_progreso:'#f59e0b', cerrada:'#10b981' };
const PC = { alta:'#ef4444', media:'#f59e0b', baja:'#10b981' };

export default function OrdenesTrabajo() {
  const [lista,      setLista]      = useState([]);
  const [proyectos,  setProyectos]  = useState([]);
  const [filtro,     setFiltro]     = useSessionState('ot_filtro', '');
  const [modal,      setModal]      = useState(false);
  const [saving,     setSaving]     = useState(false);
  const [form, setForm] = useState({ proyecto_id:'', titulo:'', descripcion:'', prioridad:'media', tecnico_id:'', fecha_inicio:'', fecha_cierre:'' });
  const [verHist, setVerHist] = useState(null);

  const load = () => getOrdenesTrabajo(filtro ? { estado: filtro } : {}).then(r => setLista(r.data));
  useEffect(() => { load(); getProyectos().then(r => setProyectos(r.data)); }, []);
  useEffect(() => { load(); }, [filtro]);

  const handleCreate = async () => {
    if (!form.proyecto_id || !form.titulo) return alert('Proyecto y título son requeridos');
    setSaving(true);
    try {
      await createOrdenTrabajo(form);
      setModal(false);
      setForm({ proyecto_id:'', titulo:'', descripcion:'', prioridad:'media', tecnico_id:'', fecha_inicio:'', fecha_cierre:'' });
      load();
    } catch (e) { alert(e.response?.data?.error || 'Error al guardar'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>Órdenes de Trabajo</h1><p style={s.sub}>Gestión de trabajos de campo</p></div>
        <RibbonActions><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <FiltroPanel
            fields={[{ tipo: 'select', label: 'Estado', value: filtro, onChange: setFiltro, capitalize: true, options: [{ value: '', label: 'Todas' }, ...ESTADOS.map(e => ({ value: e, label: e }))] }]}
            onClear={() => setFiltro('')}
          />
          <button style={s.btnPrimary} onClick={() => setModal(true)}>+ Nueva OT</button>
        </div></RibbonActions>
      </div>

      <div style={s.card}>
        <table style={s.table}>
          <thead>
            <tr>{['Número','Proyecto','Título','Prioridad','Técnico','Fecha inicio','Estado','Cambiar estado','Imprimir'].map(h =>
              <th key={h} style={s.th}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={8} style={s.empty}>Sin órdenes de trabajo</td></tr>}
            {lista.map(ot => (
              <tr key={ot.id}>
                <td style={{ ...s.td, color:'#93c5fd', fontWeight:600 }}>{ot.numero}</td>
                <td style={s.td}><span style={s.codigo}>{ot.proyecto_codigo}</span> {ot.proyecto_nombre}</td>
                <td style={s.td}>{ot.titulo}</td>
                <td style={s.td}><span style={{ ...s.badge, background:PC[ot.prioridad]+'22', color:PC[ot.prioridad] }}>{ot.prioridad}</span></td>
                <td style={s.td}>{ot.tecnico_nombre || '—'}</td>
                <td style={s.td}>{ot.fecha_inicio ? new Date(ot.fecha_inicio).toLocaleDateString('es-CO') : '—'}</td>
                <td style={s.td}><span style={{ ...s.badge, background:EC[ot.estado]+'22', color:EC[ot.estado] }}>{ot.estado}</span></td>
                <td style={s.td}>
                  <select style={s.select} value={ot.estado} onChange={e => updateEstadoOT(ot.id, e.target.value).then(load)}>
                    {ESTADOS.map(e => <option key={e} value={e}>{e}</option>)}
                  </select>
                </td>
                <td style={s.td}>
                  <button style={HIST_BTN} title="Historial" onClick={() => setVerHist({ docTipo:'ot', docId: ot.id, numero: ot.numero })}><ClockIcon /></button>
                  <BotonesDocumento tipo="ot" datos={ot} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}>
              <h2 style={s.modalTitle}>Nueva Orden de Trabajo</h2>
              <button style={s.closeBtn} onClick={() => setModal(false)}>✕</button>
            </div>
            <div style={s.modalBody}>
              <div style={s.row2}>
                <div style={s.field}>
                  <label style={s.label}>Proyecto *</label>
                  <select style={s.input} value={form.proyecto_id} onChange={e => setForm({...form, proyecto_id:e.target.value})}>
                    <option value="">Seleccionar proyecto</option>
                    {proyectos.map(p => <option key={p.id} value={p.id}>{p.codigo} — {p.nombre}</option>)}
                  </select>
                </div>
                <div style={s.field}>
                  <label style={s.label}>Prioridad</label>
                  <select style={s.input} value={form.prioridad} onChange={e => setForm({...form, prioridad:e.target.value})}>
                    {PRIO.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
              </div>
              <div style={s.field}>
                <label style={s.label}>Título *</label>
                <input style={s.input} value={form.titulo} onChange={e => setForm({...form, titulo:e.target.value})} placeholder="Descripción corta del trabajo" />
              </div>
              <div style={s.field}>
                <label style={s.label}>Descripción detallada</label>
                <textarea style={{ ...s.input, minHeight:80, resize:'vertical' }} value={form.descripcion} onChange={e => setForm({...form, descripcion:e.target.value})} />
              </div>
              <div style={s.row2}>
                <div style={s.field}>
                  <label style={s.label}>Fecha inicio</label>
                  <input style={s.input} type="date" value={form.fecha_inicio} onChange={e => setForm({...form, fecha_inicio:e.target.value})} />
                </div>
                <div style={s.field}>
                  <label style={s.label}>Fecha cierre estimada</label>
                  <input style={s.input} type="date" value={form.fecha_cierre} onChange={e => setForm({...form, fecha_cierre:e.target.value})} />
                </div>
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(false)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handleCreate} disabled={saving}>
                {saving ? 'Guardando...' : 'Crear OT'}
              </button>
            </div>
          </div>
        </div>
      )}
      {verHist && <DocHistorialModal {...verHist} onClose={() => setVerHist(null)} />}
    </div>
  );
}

const s = {
  pageHeader:  { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 },
  h1:          { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:         { color:'#64748b', fontSize:14, margin:0 },
  btnPrimary:  { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
  filtros:     { display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' },
  chip:        { background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', padding:'6px 14px', borderRadius:20, fontSize:12, cursor:'pointer' },
  chipActive:  { background:'#1d4ed8', borderColor:'#1d4ed8', color:'#fff' },
  card:        { background:'#1e293b', borderRadius:12, overflow:'hidden' },
  table:       { width:'100%', borderCollapse:'collapse' },
  th:          { padding:'12px 16px', color:'#64748b', fontSize:12, textAlign:'left', borderBottom:'1px solid #334155', background:'#162032' },
  td:          { padding:'4px 16px', color:'#cbd5e1', fontSize:13, borderBottom:'1px solid #1a2332' },
  empty:       { padding:'32px', textAlign:'center', color:'#475569' },
  badge:       { padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 },
  codigo:      { color:'#64748b', fontSize:11 },
  select:      { background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', borderRadius:6, padding:'3px 8px', fontSize:12, cursor:'pointer' },
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
  modal:       { background:'#1e293b', borderRadius:16, width:'90%', maxWidth:640, maxHeight:'90vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'13px 20px', borderBottom:'1px solid #334155' },
  modalTitle:  { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0 },
  closeBtn:    { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  modalBody:   { padding:'14px 20px', overflowY:'auto', flex:1 },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, padding:'12px 20px', borderTop:'1px solid #334155' },
  row2:        { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:0 },
  field:       { marginBottom:10 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:       { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
};
